export const addresses = {
  starAddress:"0x2782193f6aA2Dd03656585AB30e18451534392e6",
}
